/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RecipientStatus = {
    Pending: 'pending',
    NeedsMoreInfo: 'needs_more_info',
    Accepted: 'accepted',
    Declined: 'declined',
    Confirmed: 'confirmed',
    Closed: 'closed',
} as const;
export type RecipientStatus = typeof RecipientStatus[keyof typeof RecipientStatus];


export function instanceOfRecipientStatus(value: any): boolean {
    for (const key in RecipientStatus) {
        if (Object.prototype.hasOwnProperty.call(RecipientStatus, key)) {
            if (RecipientStatus[key as keyof typeof RecipientStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RecipientStatusFromJSON(json: any): RecipientStatus {
    return RecipientStatusFromJSONTyped(json, false);
}

export function RecipientStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecipientStatus {
    return json as RecipientStatus;
}

export function RecipientStatusToJSON(value?: RecipientStatus | null): any {
    return value as any;
}

export function RecipientStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): RecipientStatus {
    return value as RecipientStatus;
}

